export const round2 = (value: number): number => Math.round(value * 100) / 100;

export const roundNullable = (value: number | null | undefined): number | null => {
  if (value == null) return null;
  return round2(value);
};
